import {
    AppSettings,
    JournalSettings,
    PatchAppSettingsInput,
} from "../../../types/api/admin/settings";
import { request } from "../../apiService";

export const getAppSettings = async () => {
    return await request<AppSettings>(`/v3/admin/settings`);
};

export const patchAppSettings = async (input: PatchAppSettingsInput) => {
    return await request<AppSettings, PatchAppSettingsInput>(
        `/v3/admin/settings`,
        {
            method: "PATCH",
            input,
        }
    );
};

/** Lecture trader (auth) — options MM + challenge + base démo. */
export const getJournalSettings = async () => {
    return await request<JournalSettings>(`/v3/settings/journal`);
};
